import { motion } from "framer-motion";
import { HelpCircle } from "lucide-react";
import { SEO } from "@/components/SEO";

// Temporarily commented out – FAQ content coming soon
// const faqs = [
//   { q: "What are your hours of operation?", a: "Hours vary by location..." },
//   { q: "How do I cancel my membership?", a: "Submit a cancellation request..." },
//   { q: "Do you offer guest passes or trial visits?", a: "Policies vary by location..." },
//   { q: "What is Jersey Girls Fitness?", a: "Jersey Girls is our women-only fitness experience..." },
//   { q: "How do I update my contact information or billing?", a: "Visit your home club in person..." },
//   { q: "Who do I contact for support?", a: "For general questions, use our Contact Us form..." },
// ];

export default function FAQPage() {
  return (
    <div className="min-h-screen pt-20" data-testid="faq-page">
      <SEO
        title="Frequently Asked Questions"
        description="Frequently asked questions about Giant Fitness. Coming soon."
        url="/support"
        noindex={true}
      />
      <section className="py-12 md:py-20 px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-brand-orange/20 flex items-center justify-center">
              <HelpCircle className="w-8 h-8 text-brand-orange" />
            </div>
            <h1 className="text-4xl md:text-5xl font-heading font-black text-gray-900 mb-4 text-center" data-testid="faq-heading">
              FREQUENTLY ASKED QUESTIONS
            </h1>
            <p className="text-gray-600 text-2xl font-heading font-bold text-center py-12" data-testid="faq-coming-soon">
              Coming Soon!
            </p>

            {/* "Still have questions?" link commented out temporarily */}
              {/* Still have questions? <Link to="/contact" className="text-brand-orange hover:underline font-medium">Contact us</Link> and we’ll get back to you shortly. */}
          </motion.div>
        </div>
      </section>
    </div>
  );
}
